<template>
  <div class="wrapper-container">
    <div class="container-widget-header">
      <h3>ADMIN USERS</h3>
      <div class="call-actions">
        <button class="btn-success" @click="addNew()">
          <img src="@/assets/images/icons/plus.svg" /> CREATE USER
        </button>
      </div>
    </div>
    <div class="body-widget">
      <div class="table-widget">
        <table>
          <tr>
            <th>Names</th>
            <th>Phone</th>
            <th>Image</th>
            <th>Email</th>
            <th></th>
          </tr>
          <tr v-for="(item, index) in user_data" :key="index">
            <td>{{ item.first_name }} {{ item.last_name }}</td>
            <td>{{ item.phone }}</td>
            <td>
              <img v-if="item.profile_image" class="affiliate-image" :src="$store.state.ASSETS_BASE_URL +
                'assets/uploaded/' +
                item.profile_image
                " />
              <img v-else src="@/assets/images/icons/empty_profile.svg" alt />
            </td>
            <td>{{ item.email }}</td>
            <td>
              <dropdown-menu v-model="item.is_menu_open" :right="false" :hover="false" :interactive="false"
                class="shop-menu">
                <button class="dropdown-toggle">
                  <img src="@/assets/images/icons/menu.svg" />
                </button>
                <div slot="dropdown" class="drop-down-menu">
                  <a class="dropdown-item" @click.prevent="setPermmission(item)">
                    Set Permission
                  </a>
                  <a class="dropdown-item" @click.prevent="editItem(item)">
                    <img src="@/assets/images/icons/edit.svg" /> Edit
                  </a>
                  <a class="dropdown-item" @click.prevent="deleteItem(item)">
                    <img src="@/assets/images/icons/trash.svg" /> Delete
                  </a>
                </div>
              </dropdown-menu>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- Add Modal -->
    <div class="overlay" v-if="show_form">
      <div class="form-widget">
        <div class="header">
          <h3 v-if="!form.id">Add New User</h3>
          <h3 v-else>Update User</h3>
        </div>
        <div class="body">
          <div class="input-group">
            <label>First name</label>
            <div class="input-widget">
              <input type="text" v-model="form.first_name" class="bg-cagura-form-control" />
            </div>
          </div>

          <div class="input-group">
            <label>Last name</label>
            <div class="input-widget">
              <input type="text" v-model="form.last_name" class="bg-cagura-form-control" />
            </div>
          </div>

          <div class="input-group">
            <label>Profile Image</label>
            <div class="input-widget">
              <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
                location="assets/uploaded/" :url="$store.state.SITE_ASSETS_BASE_URL"
                :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.profile_image"
                @onFileSelected="onImageSelected">
                <div class="image-upload-widget">Choose Image to upload</div>
              </upload-trigger>
            </div>
          </div>
          <div class="input-group">
            <label>Phone</label>
            <div class="input-widget">
              <input type="text" v-model="form.phone_number" class="bg-cagura-form-control" />
            </div>
          </div>
          <div class="input-group">
            <label>Email</label>
            <div class="input-widget">
              <input type="text" v-model="form.email" class="bg-cagura-form-control" />
            </div>
          </div>
          <div class="input-group" v-if="!form.id">
            <label>Password</label>
            <div class="input-widget">
              <input type="text" v-model="form.password" class="bg-cagura-form-control" />
            </div>
          </div>
        </div>
        <div class="footer">
          <c-button :loading="loading" @click="submitForm()" class="btn-success">Save</c-button>
          <button @click="show_form = false" class="btn-default">Cancel</button>
        </div>
      </div>
    </div>

    <div class="overlay" v-if="show_set_perm">
      <div class="form-widget">
        <div class="header">
          <h3>Set Permission</h3>
        </div>
        <div class="body">
          <div v-for="(item, index) in permssion_list" :key="index">
            <input type="checkbox" :checked="CheckPermission(item.unique_index)" :id="index + 'per'"
              @change="onchangePermission($event, item.unique_index)" />
            <label :for="index + 'per'">{{ item.name }}</label>
          </div>
        </div>
        <div class="footer">
          <button @click="show_set_perm = false" class="btn-default">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data: () => ({
    menu: false,
    loading: false,
    form: {
      id: null,
      first_name: "",
      last_name: "",
      profile_image: "",
      phone_number: "",
      email: "",
      password: "",
    },
    show_form: false,
    show_set_perm: false,
    user_data: [],
    permssion_list: [],
    user_permissions: [],
    permission_form: {
      unique_index: "",
      user_id: null,
      status: 0,
    },
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getUserData();
    vm.getPermissionList();
  },
  methods: {
    CheckPermission(unique_index) {
      let vm = this;
      return vm.user_permissions.includes(unique_index);
    },
    onchangePermission({ target }, unique_index) {
      let vm = this;
      vm.permission_form.unique_index = unique_index;
      vm.permission_form.status = target.checked ? 1 : 0;
      vm.$store
        .dispatch("ADMIN_CHANGE_PERMSSION", vm.permission_form)
        .then((response) => {
          vm.getUserData();
        })
        .catch(({ response }) => { });
    },
    getPermissionList() {
      let vm = this;
      vm.$store
        .dispatch("ADMIN_GET_PERMSSION_LIST")
        .then((response) => {
          vm.permssion_list = response.data.return;
        })
        .catch(({ response }) => { });
    },
    setPermmission(item) {
      let vm = this;
      vm.permission_form.user_id = item.id;
      vm.user_permissions = item.permission.map((item) => {
        return item.unique_index;
      });
      vm.show_set_perm = true;
    },
    confirmDelete(id) {
      let vm = this;
      vm.$store
        .dispatch("ADMIN_USER_DELETE_ITEM", { id: id })
        .then((response) => {
          vm.getUserData();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Important message",
            text: response.data.message,
          });
        })
        .catch(({ response }) => {
          console.error("ADMIN_USER_DELETE_ITEM", { response });
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: response.data.message,
          });
        });
    },
    deleteItem(item) {
      let vm = this;
      vm.$confirm({
        title: "Confirm",
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            vm.confirmDelete(item.id);
          }
        },
      });
    },
    editItem(item) {
      let vm = this;
      vm.form.id = item.id;
      vm.form.first_name = item.first_name;
      vm.form.last_name = item.last_name;
      vm.form.profile_image = item.profile_image;
      vm.form.phone_number = item.phone;
      vm.form.email = item.email;
      vm.form.password = item.password;
      vm.show_form = true;
    },
    getUserData() {
      let vm = this;
      vm.$store
        .dispatch("ADMIN_USER_GET_USERS")
        .then((response) => {
          vm.user_data = response.data.return.map((item) => {
            vm.$store.state.eventBus.$set(item, "is_menu_open", false);
            return item;
          });
        })
        .catch(({ response }) => {
          console.log("ADMIN_USER_GET_USERS", { error });
        });
    },
    submitForm() {
      let vm = this;
      vm.loading = true;
      if (!vm.form.id) {
        vm.$store
          .dispatch("ADMIN_USER_ADD_NEW", vm.form)
          .then((response) => {
            vm.loading = false;
            vm.getUserData();
            vm.show_form = false;
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
            console.log("ADMIN_USER_ADD_NEW", { error });
          });
      } else {
        vm.$store
          .dispatch("ADMIN_USER_UPDATE", vm.form)
          .then((response) => {
            vm.loading = false;
            vm.getUserData();
            vm.show_form = false;
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
            console.log("ADMIN_USER_UPDATE", { error });
          });
      }
    },
    addNew() {
      let vm = this;
      vm.show_form = true;
      vm.form = {
        id: null,
        first_name: "",
        last_name: "",
        profile_image: "",
        phone: "",
        email: "",
        password: "",
      };
    },
    onImageSelected(file) {
      let vm = this;
      vm.form.profile_image = file;
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper-container {
  display: flex;
  flex-direction: column;

  .container-widget-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
  }

  .body-widget {
    height: calc(100vh - 122px);
    overflow-y: auto;

    .table-widget {
      width: 100%;
      padding: 0px 10px;

      table {
        width: 100%;

        th {
          height: 45px;
          background: #ddd;
          border: 1px solid #fff;
          padding: 15px;
        }

        td {
          border: 1px solid #ddd;
          padding: 15px;

          .shop-menu {
            position: relative;
          }

          .affiliate-image {
            width: 40px;
            height: 40px;
          }
        }
      }
    }
  }

  .overlay {
    display: flex;
    justify-content: center;
    padding-top: 80px;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    align-items: unset;

    .form-widget {
      height: 600px;
      width: 400px;
      background: #fff;
      border: 1px solid #ccc;
      border-radius: 5px;
      display: flex;
      flex-direction: column;

      .header {
        height: 60px;
        display: flex;
        align-items: center;
        padding: 0px 15px;
        border-bottom: 1px solid #ccc;

        h3 {
          margin: 0px;
        }
      }

      .body {
        height: calc(100% - 120px);
        overflow-y: auto;
        padding: 15px;
      }

      .footer {
        background: rgb(250, 250, 250);
        border-top: 1px solid #ccc;
        height: 60px;
        display: flex;
        align-items: center;
        padding: 0px 15px;

        button {
          margin-right: 20px;
        }
      }
    }
  }

  .on-fly-options {
    position: fixed;
    bottom: 20px;
    right: 20px;

    .btn-cycle {
      height: 50px !important;
      width: 50px !important;
      min-width: 50px !important;
      border-radius: 50%;
      font-size: 29px;
      background: #fff;
      box-shadow: 0px 0px 6px #000;
    }
  }
}
</style>
